import { useState, useRef, useEffect } from 'react';

export default function AutocompleteInput({
  value,
  onChange,
  suggestions = [],
  placeholder = '',
  className = '',
  testId = '',
  ...props
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (value && isOpen) {
      const query = value.toLowerCase();
      const matches = suggestions
        .filter(s => s.toLowerCase().includes(query) && s.toLowerCase() !== query)
        .slice(0, 8);
      setFiltered(matches);
    } else {
      setFiltered([]);
    }
  }, [value, suggestions, isOpen]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={wrapperRef} className="relative">
      <input
        value={value}
        onChange={e => onChange(e.target.value)}
        onFocus={() => setIsOpen(true)}
        placeholder={placeholder}
        className={`editable-field ${className}`}
        data-testid={testId}
        {...props}
      />
      {isOpen && filtered.length > 0 && (
        <div className="autocomplete-dropdown" data-testid={`${testId}-dropdown`}>
          {filtered.map((item, i) => (
            <div
              key={item}
              className="autocomplete-item"
              onMouseDown={(e) => {
                e.preventDefault();
                onChange(item);
                setIsOpen(false);
              }}
              data-testid={`${testId}-option-${i}`}
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
